import type { TextAlignment, FontFamily } from '../../types'
import {
    DEFAULT_FONT_FAMILY,
    AVAILABLE_FONTS,
    AVAILABLE_ALIGNMENTS,
} from '../../constants'

/**
 * Type guard для проверки, является ли строка валидным выравниванием
 */
function isValidAlignment(alignment: string): alignment is TextAlignment {
    return AVAILABLE_ALIGNMENTS.includes(alignment as TextAlignment)
}

/**
 * Type guard для проверки, является ли строка валидным шрифтом
 */
function isValidFontFamily(fontFamily: string): fontFamily is FontFamily {
    return AVAILABLE_FONTS.includes(fontFamily as FontFamily)
}

/**
 * Валидация выравнивания текста
 * @param alignment - выравнивание
 * @returns валидированное выравнивание или значение по умолчанию
 */
export function validateAlignment(
    alignment: string | null | undefined
): TextAlignment {
    if (alignment && isValidAlignment(alignment)) {
        return alignment
    }
    return 'center' // Значение по умолчанию
}

/**
 * Валидация семейства шрифтов
 * @param fontFamily - семейство шрифтов
 * @returns валидированное семейство шрифтов или значение по умолчанию
 */
export function validateFontFamily(
    fontFamily: string | null | undefined
): FontFamily {
    if (fontFamily && isValidFontFamily(fontFamily)) {
        return fontFamily
    }
    return DEFAULT_FONT_FAMILY // Значение по умолчанию
}
